module.exports = __webpack_public_path__ + "static/Ieva_Sadauskaite-8dfca60b355e0ce38d70c916524fb594.jpg";